import { useSidepanel } from '../../../../../../../shared/contexts/Sidepanel.provider';
import { CreateOrEditResponseProjectPanel } from '../createOrEditResponseProjectPanel';

export interface UseCreateOrEditResponseProjectPanelProps {
  id?: number;
}

export function useCreateOrEditResponseProjectPanel(
  props: UseCreateOrEditResponseProjectPanelProps,
) {
  const { togglePanel: _togglePanel, closePanel } = useSidepanel();

  function togglePanel() {
    _togglePanel({
      content: (
        <CreateOrEditResponseProjectPanel closePanel={closePanel} {...props} />
      ),
    });
  }

  return { togglePanel, closePanel };
}
